export class DtoCoDocumentoCobrar {

    dataKey: string;

    fechaDocumento: Date;
    fechaVencimiento: Date;
    diasVencimiento: number;
    clienteNumero: number;
    montoTotal: number;
    montoPagado: number;
    montoAdelandoSaldo: number;
    apProcesoSecuencia: number;
    vendedor: number;
    clienteCobrara: number;
    apProcesoNumero: number;
    totalClientes: number;
    busquead: string;
    unidadNegocio: string;
    comentario: string;
    tipoCanjeFactura: string;
    tipoVenta: string;
    formaDePago: string;
    codigo01: string;
    codigo02: string;
    formaFacturacion: string;
    voucherPedido: string;
    voucherNo: string;
    estado: string;
    impresionPendienteFlag: string;
    procesoImportacionNumero: string;
    numeroInterno: string;
    apTransferidoFlag: string;
    clienteNombre: string;
    monedaDocumento: string;
    companiaSocio: string;
    tipoDocumento: string;
    clasificacion: string;
    numeroDocumento: string;
    montoPendiente: number;
    letraNumeroUnico: string;
    diasRetraso: number;

    pendienteLo: number;
    pendienteEx: number;
    montoPendienteDolares: number;
    montoPendienteSoles: number;
    cantidadDocumentos: number;
    totalMontoLetras: number;
    metaLineasPropias: number;
    transaccionCodigo: string;
    periodo: string;
    almacenCodigo: string;
    comercialGuiaNumero: string;
    referenciaNumeroDocumento: string;
    nroTransaccion: string;
    metaCantidadProductos: number;
    nombreCompleto: string;
    montoAvance: number;
    montoCP: number;
    nt: number;
    nl: number;
    metaMargen: number;
    metaMonto: number;
    margenAvance: number;
    montoLineasPropias: number;
    clientesFacturados: number;
    mixProd: number;
    porcentajeMontoVenta: number;
	porcentajeMargenVenta: number;
	porcentajeLineaPropia: number;
	porcentajeProductosVendidos: number;
	porcentajeClienteAtendidos: number;
}
